var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrEditResource',{on:{"breadcrumb-data-changed":function($event){return _vm.setBreadcrumb($event.route, $event.routeName)}}})}
var staticRenderFns = []

export { render, staticRenderFns }